import { render, staticRenderFns } from "./retrievePwd_view.vue?vue&type=template&id=16b38836&scoped=true&"
import script from "./retrievePwd_view.vue?vue&type=script&lang=js&"
export * from "./retrievePwd_view.vue?vue&type=script&lang=js&"
import style0 from "./retrievePwd_view.vue?vue&type=style&index=0&id=16b38836&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b38836",
  null
  
)

export default component.exports